// extracted by mini-css-extract-plugin
export var closeButton = "_1o-0";